export default "__VITE_ASSET__B1v0POhs__"